module.exports = __webpack_public_path__ + "image/search.png";